import { trimChars } from 'lodash/fp';

export function getServerOrigin(path: string): string {
  const GUINEA_PIGS = 0.25;
  const GUINEA_PIG_PATHS: string[] = [];

  const trimmedPath = trimChars('/')(path);

  const NEW_BACKEND_PATHS = [
    'analyze_link',
    'analyze_link_custom',
    'create_post_collage',
    'create_post_fixed_carousel',
    'create_post_multi_carousel',
    'create_post_multi_custom_carousel',
    'create_post_property_carousel',
    'create_post_single_link',
    'create_post_video_link',
    'get_agent_id_office_id_from_mls',
    'get_count_for_office_id_agent_id',
    'get_domain_setting',
    'get_posts',
    'get_posts_by_mls_number',
    'get_search_id',
    'login_new',
    'logout',
    'oauth_callback',
    'set_dns_verification',
    'set_domain_setting',
    'can_customize_link_posts',
    'fb_proxy',
  ];

  // Default to localhost if test to prevent errors that FBADBAE_SERVER and RG_SERVER are undefined
  if (process.env.NODE_ENV === 'test') {
    return 'http://localhost:8888';
  }

  if (GUINEA_PIG_PATHS.includes(trimmedPath)) {
    if (Math.random() < GUINEA_PIGS) {
      return (process.env.FBADBAE_SERVER as string);
    }
    return (process.env.RG_SERVER as string);
  }

  if (NEW_BACKEND_PATHS.includes(trimmedPath) && process.env.FBADBAE_SERVER) {
    return process.env.FBADBAE_SERVER;
  }

  if (process.env.RG_SERVER) {
    return process.env.RG_SERVER;
  }

  // If url not specified. We assume that we are hitting a local path
  return 'http://localhost:5000';
}

export function getServerUrl(path: string): string {
  return `${getServerOrigin(path)}/${trimChars('/')(path)}`;
}
